import script from "./AdminHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHomePage.vue?vue&type=script&setup=true&lang=js"

import "./AdminHomePage.vue?vue&type=style&index=0&id=65d49ce3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d49ce3"]])

export default __exports__